import {
  ON_START_GET_SIGNERAD_FILE,ON_GET_SIGNERAD_FILE,ON_ERROR_GET_SIGNERAD_FILE,
    ON_START_NEW_ESIGNERING,ON_NEW_ESIGNERING,ON_ERROR_NEW_ESIGNERING,SET_ZERO_ESIGNERING,
    ON_START_GET_ESIGNERIGN_USER,ON_GET_ESIGNERIGN_USER,ON_ERROR_GET_ESIGNERIGN_USER,
    ON_START_GET_ESIGNERIGN_ID,ON_GET_ESIGNERIGN_ID,ON_GET_ESIGNERIGN_ID_FROM_OFFERT_PROCESS,ON_ERROR_GET_ESIGNERIGN_ID,
    ON_START_GET_TIMELINE,ON_GET_ESIGNERIGN_TIMELINE,ON_ERROR_GET_ESIGNERIGN_TIMELINE,
    ON_START_ESIGNERING_SKICKA,ON_ESIGNERING_SKICKA,ON_ERROR_ESIGNERING_SKICKA,
    ON_START_ESIGNERING_RECALL,ON_ESIGNERING_RECALL,ON_ERROR_ESIGNERING_RECALL,
    ON_START_ESIGNERING_RESTART,ON_ESIGNERING_RESTART,ON_ERROR_ESIGNERING_RESTART,
    ON_START_ESIGNERING_DELETE,ON_ESIGNERING_DELETE,ON_ERROR_ESIGNERING_DELETE,
    ON_START_GET_ESIGNERIGN_HISTORY,ON_GET_ESIGNERIGN_HISTORY,ON_ERROR_GET_ESIGNERIGN_HISTORY,
    ON_START_UPDATE_ESIGNERIGN_MESSAGE,ON_UPDATE_ESIGNERIGN_MESSAGE,ON_ERROR_UPDATE_ESIGNERIGN_MESSAGE,
    ON_START_UPDATE_ESIGNERIGN_MOTAGARE,ON_UPDATE_ESIGNERIGN_MOTAGARE,ON_ERROR_UPDATE_ESIGNERIGN_MOTAGARE,
    ON_START_NEW_ESIGNERIGN_MOTAGARE,ON_NEW_ESIGNERIGN_MOTAGARE,ON_ERROR_NEW_ESIGNERIGN_MOTAGARE,
    ON_START_DELETE_ESIGNERIGN_MOTAGARE,ON_DELETE_ESIGNERIGN_MOTAGARE,ON_ERROR_DELETE_ESIGNERIGN_MOTAGARE,
    ON_START_UPDATE_ESIGNERIGN_FILE,ON_UPDATE_ESIGNERIGN_FILE,ON_ERROR_UPDATE_ESIGNERIGN_FILE,
    ON_START_GET_ESIGNERIGN_AVTAL,ON_GET_ESIGNERIGN_AVTAL,ON_ERROR_GET_ESIGNERIGN_AVTAL,
    ON_START_GET_ESIGNERIGN_ORGNR,ON_GET_ESIGNERIGN_ORGNR,ON_ERROR_GET_ESIGNERIGN_ORGNR,
    ON_START_ESIGNERING_ORGNR_DELETE,ON_ESIGNERING_ORGNR_DELETE,ON_ERROR_ESIGNERING_ORGNR_DELETE,
    ON_OPEN_FILTER_ESIGNERING, ON_ClOSE_FILTER_ESIGNERING,SET_ESIGNERING_FILTER,
    ON_START_SEND_ESIGNERIGN_REMAINDER,ON_SEND_ESIGNERIGN_REMAINDER,ON_ERROR_SEND_ESIGNERIGN_REMAINDER,
    ON_START_ADD_ESIGNERIGN_ATTAC_FILE,ON_ADD_ESIGNERIGN_ATTAC_FILE,ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE,
    ON_START_DEL_ATT_FILE,ON_DEL_ATT_FILE,ON_ERROR_DEL_ATT_FILE,
    ON_START_GET_SIG_FILE,ON_GET_SIG_FILE,ON_ERROR_GET_SIG_FILE,SET_ESIGNVY_TYPE, UNSET_ESIGNVY_TYPE,
    SET_ESIGNVY_PAGE_ROWS,
    ON_START_ESIGNERING_NEW_FREEIPUT,ON_ESIGNERING_NEW_FREEIPUT,ON_ERROR_ESIGNERING_NEW_FREEIPUT,
    ON_START_ESIGNERING_DELETE_FREEIPUT,ON_ESIGNERING_DELETE_FREEIPUT,ON_ERROR_ESIGNERING_DELETE_FREEIPUT,
    ON_START_ESIGNERING_EDIT_FREEIPUT,ON_ESIGNERING_EDIT_FREEIPUT,ON_ERROR_ESIGNERING_EDIT_FREEIPUT,
    ON_START_ESIGNERING_UPDATE_NYTT,ON_GET_UPDATE_ESIGNERING_ERROR,ON_GET_UPDATE_ESIGNERING,ON_GET_UPDATE_ESIGNERING_KUNDNAMN,
		ON_GET_START_ESIGNERING_PROCESS
} from "../constants/ActionTypes";
import {isUndefined,isEmpty} from 'lodash'
import { translate } from "../util/intlHelper";
const INIT_STATE = {
    EsigneringList:[],
    currentEsingering:{},
    EsigneringHistory:[],
    isLoadingEsingering:false,
		isProcessing: false,
    Esingeringtmessage:"",
    TotalEsingering:{},
    ResponseMsgEsignering:{},
    MainTimeLine:[],
    FilesBilagor:[],
    FreeInputs:[],
    MotArbetareEsignering:[],
    FilterEsigneringPopup:false,
    EsigneringFilterOption:isUndefined(localStorage.EsigneringFilter)?[]:JSON.parse(localStorage.EsigneringFilter), 
    EsigneringPageRows: 25,
    currentEsignVYIndex: 0,
}

const parseWebSocketJSON = (str) =>{
	try{
		return JSON.parse(str)
	} catch(err) {
		return {}
	}
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_ZERO_ESIGNERING:{
            return INIT_STATE;
        }
				case ON_GET_START_ESIGNERING_PROCESS: {
					return {
						...state,
						isProcessing: true
					}
				}
				case ON_GET_UPDATE_ESIGNERING_ERROR:{
					try{
						let dataobj = parseWebSocketJSON(action.payload)
						return {
							...state,
							isProcessing: false,
              ResponseMsgEsignering:{msg:dataobj.data,type:"error",loading:false},
						}
					} catch(err){}	
				}
				case ON_GET_UPDATE_ESIGNERING:{	
					try{
					let dataobj = parseWebSocketJSON(action.payload)
					return {
						...state,
              isLoadingEsingering:false,
							isProcessing: false,
              currentEsingering: { 
								...state.currentEsingering,
								...dataobj.data.CurrentEsignering
							},
              MainTimeLine:dataobj.data.CurrentEsignering.TimeLine,
              MotArbetareEsignering:dataobj.data.CurrentEsignering.Mottagare,
              FilesBilagor:dataobj.data.CurrentEsignering.FilesBilagor,
              FreeInputs:dataobj.data.CurrentEsignering.FreeInputs,
              ResponseMsgEsignering:{msg:translate("Action.Esigning.fetch1"),type:"success",loading:false},
					}
					} catch(err) {
						return state
					}
				}
			  case ON_GET_UPDATE_ESIGNERING_KUNDNAMN: {
					try {
						let dataobj = parseWebSocketJSON(action.payload)
						return {
							...state,
              currentEsingering: { 
								...state.currentEsingering,
								KundName: dataobj.data.KundName
							},
					}
					} catch(err) {
						return state
					}
				}

        case SET_ESIGNVY_PAGE_ROWS:{
          return { ...state,
            EsigneringPageRows: action.payload,
          };
        }
        case SET_ESIGNVY_TYPE:{
          localStorage.setItem("currentEsignVYIndex", JSON.stringify(action.payload));
          return { ...state,
            currentEsignVYIndex: action.payload,
          };
        }
        case UNSET_ESIGNVY_TYPE:{
          localStorage.removeItem("currentEsignVYIndex");
          return { ...state,
            currentEsignVYIndex: 0,
          };
        }
          case SET_ESIGNERING_FILTER: {
            console.log("SET_ESIGNERING_FILTER",action.payload)
            localStorage.removeItem("EsigneringFilter");
            localStorage.setItem("EsigneringFilter", JSON.stringify(action.payload));
            return { ...state,
              EsigneringFilterOption: action.payload
            };
          }
        case ON_START_NEW_ESIGNERING:{
            console.log("ON_START_NEW_ESIGNERING",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true,
              currentEsingering:{},
              FilesBilagor:[],
              FreeInputs:[],
              MotArbetareEsignering:[],
              FilterEsigneringPopup:false,
              EsigneringHistory:[]
            }
          }
          case ON_OPEN_FILTER_ESIGNERING:{
            console.log("ON_OPEN_FILTER_ESIGNERING",action)
            return {
              ...state,
              FilterEsigneringPopup:true
            }
          }
        case ON_ClOSE_FILTER_ESIGNERING:{
            console.log("ON_ClOSE_FILTER_ESIGNERING",action)
            return {
              ...state,
              FilterEsigneringPopup:false
            }
          }
        case ON_NEW_ESIGNERING:{
            console.log("ON_NEW_ESIGNERING",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.Save"),
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare
            }
          }
        case ON_ERROR_NEW_ESIGNERING:{
            console.log("ON_ERROR_NEW_ESIGNERING",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false,
              currentEsingering:{}
            }
          }
        case ON_START_GET_ESIGNERIGN_USER:{
            console.log("ON_START_GET_ESIGNERIGN_USER",action)
            return {
              ...state,
              ResponseMsgEsignering:{msg:translate("Action.EsigningList.fetching"),type:"info",loading:true},
              Esingeringtmessage:"",
              isLoadingEsingering:true,
              currentEsingering:{},
              //EsigneringList:[],
              MotArbetareEsignering:[],
              FilesBilagor:[],
              FreeInputs:[],
              EsigneringHistory:[],
             // TotalEsingering:{},
            }
          }
        case ON_GET_ESIGNERIGN_USER:{
            console.log("ON_GET_ESIGNERIGN_USER",action)
            return {
              ...state,
              Esingeringtmessage:"",
              ResponseMsgEsignering:{msg:translate("Action.EsigningList.fetch"),type:"success",loading:false},
              isLoadingEsingering:false,
              EsigneringList:action.payload.Esignering,
              TotalEsingering:action.payload.Antal,
              // TotalEsingering:action.payload.Esignering.length
            }
          }
        case ON_ERROR_GET_ESIGNERIGN_USER:{
            console.log("ON_ERROR_GET_ESIGNERIGN_USER",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Error.Esigninglist.fetch"),type:"error",loading:false},
              Esingeringtmessage:"",
              isLoadingEsingering:false
            }
          }
        case ON_START_GET_ESIGNERIGN_AVTAL:{
            console.log("ON_START_GET_ESIGNERIGN_AVTAL",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true,
              currentEsingering:{},
              EsigneringList:[],
              MotArbetareEsignering:[],
              FilesBilagor:[],
              FreeInputs:[],
              EsigneringHistory:[],
              TotalEsingering:{},
            }
          }
        case ON_GET_ESIGNERIGN_AVTAL:{
            console.log("ON_GET_ESIGNERIGN_AVTAL",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:false,
              EsigneringList:action.payload.Esignering,
             TotalEsingering:action.payload.Antal,
              // TotalEsingering:action.payload.Esignering.length,
            }
          }
        case ON_ERROR_GET_ESIGNERIGN_AVTAL:{
            console.log("ON_ERROR_GET_ESIGNERIGN_AVTAL",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }
        //ON_START_ESIGNERING_ORGNR_DELETE,ON_ESIGNERING_ORGNR_DELETE,ON_ERROR_ESIGNERING_ORGNR_DELETE,
        case ON_START_ESIGNERING_ORGNR_DELETE:{
          console.log("ON_START_ESIGNERING_ORGNR_DELETE",action)
          return {
            ...state,
          }
        }
        case ON_ESIGNERING_ORGNR_DELETE:{
          console.log("ON_ESIGNERING_ORGNR_DELETE",action)
          let EsigneringList = state.EsigneringList.filter(item=>parseInt(item.id) !== parseInt(action.payload.EsigneringId))
          return {
            ...state,
            Esingeringtmessage:"",
            isLoadingEsingering:false,
            EsigneringList:EsigneringList,
            TotalEsingering:{total:parseInt(state.TotalEsingering.total) -1 },
          //  TotalEsingering:action.payload.Esignering.length
          }
        }
      case ON_ERROR_ESIGNERING_ORGNR_DELETE:{
          console.log("ON_ERROR_ESIGNERING_ORGNR_DELETE",action)
          return {
            ...state,
            Esingeringtmessage: translate("Error.Esigning"),
            isLoadingEsingering:false
          }
        }
        //
        case ON_START_GET_ESIGNERIGN_ORGNR:{
            console.log("ON_START_GET_ESIGNERIGN_ORGNR",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true,
              currentEsingering:{},
              EsigneringList:[],
              MotArbetareEsignering:[],
              FilesBilagor:[],
              FreeInputs:[],
              EsigneringHistory:[],
              TotalEsingering:{},
            }
          }
        case ON_GET_ESIGNERIGN_ORGNR:{
            console.log("ON_GET_ESIGNERIGN_ORGNR",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:false,
              EsigneringList:action.payload.Esignering,
              TotalEsingering:action.payload.Antal,
            //  TotalEsingering:action.payload.Esignering.length
            }
          }
        case ON_ERROR_GET_ESIGNERIGN_ORGNR:{
            console.log("ON_ERROR_GET_ESIGNERIGN_ORGNR",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }

          
        case ON_START_GET_ESIGNERIGN_ID:{
            console.log("ON_START_GET_ESIGNERIGN_ID",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true,
              currentEsingering:{},
              //EsigneringList:[],
              EsigneringHistory:[],
              MotArbetareEsignering:[],
              FilesBilagor:[],
              FreeInputs:[],
              //TotalEsingering:{},
              ResponseMsgEsignering:{msg:translate("Action.EsigningCard.fetching"),type:"info",loading:true},
            }
          }
        case ON_GET_ESIGNERIGN_ID_FROM_OFFERT_PROCESS:{
            console.log("ON_GET_ESIGNERIGN_ID",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
              ResponseMsgEsignering:{msg:translate("Action.Esigning.Uploading.file"), type: 'success', loading:true},
            }
          }
        case ON_GET_ESIGNERIGN_ID:{
            console.log("ON_GET_ESIGNERIGN_ID",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
              ResponseMsgEsignering:{msg:translate("Action.Esigning.fetch1"),type:"success",loading:false},
            }
          }
        case ON_ERROR_GET_ESIGNERIGN_ID:{
            console.log("ON_ERROR_GET_ESIGNERIGN_ID",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              ResponseMsgEsignering:{msg:translate("Error.Esigning.fetching"),type:"error",loading:false},
              isLoadingEsingering:false
            }
          }
        case ON_START_GET_TIMELINE:{
            console.log("ON_START_GET_TIMELINE",action)
            return {
              ...state,
              Esingeringtmessage:"",
             }
          }
        case ON_GET_ESIGNERIGN_TIMELINE:{
            console.log("ON_GET_ESIGNERIGN_TIMELINE",action)
            return {
              ...state,
              MainTimeLine:action.payload.MainTimeLine,
              currentEsingering:{
                ...state.currentEsingering,
                scriveHistorik:isEmpty(action.payload.scriveHistorik)?state.currentEsingering.scriveHistorik:action.payload.scriveHistorik
              },
              MotArbetareEsignering:action.payload.Mottagare
            }
          }
        case ON_ERROR_GET_ESIGNERIGN_TIMELINE:{
            console.log("ON_ERROR_GET_ESIGNERIGN_TIMELINE",action)
            return {
              ...state
            }
          }
        case ON_START_ESIGNERING_SKICKA:{
            console.log("ON_START_ESIGNERING_SKICKA",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true
             }
          }
        case ON_ESIGNERING_SKICKA:{
            console.log("ON_ESIGNERING_SKICKA",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.send"),
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
            }
          }
        case ON_ERROR_ESIGNERING_SKICKA:{
            console.log("ON_ERROR_ESIGNERING_SKICKA",action)
            return {
              ...state,
              Esingeringtmessage:isUndefined(action.payload) ? translate("Error.Esigning"): (translate("Error.Esigning")+ action.payload),
              isLoadingEsingering:false
            }
          }
        case ON_START_ESIGNERING_RECALL:{
            console.log("ON_START_ESIGNERING_RECALL",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true
             }
          }
        case ON_ESIGNERING_RECALL:{
            console.log("ON_ESIGNERING_RECALL",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.recall"),
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
            }
          }
        case ON_ERROR_ESIGNERING_RECALL:{
            console.log("ON_ERROR_ESIGNERING_SKICKA",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }
        case ON_START_ESIGNERING_RESTART:{
            console.log("ON_START_ESIGNERING_RESTART",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true
             }
          }
        case ON_ESIGNERING_RESTART:{
            console.log("ON_ESIGNERING_RESTART",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.restart"),
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
            }
          }
        case ON_ERROR_ESIGNERING_RESTART:{
            console.log("ON_ERROR_ESIGNERING_RESTART",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }
        case ON_START_ESIGNERING_DELETE:{
            console.log("ON_START_ESIGNERING_DELETE",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true,
              currentEsingering:{},
              MotArbetareEsignering:[],
              FilesBilagor:[],
              FreeInputs:[],
             }
          }
        case ON_ESIGNERING_DELETE:{
            console.log("ON_ESIGNERING_DELETE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.delete"),
              isLoadingEsingering:false,
              EsigneringList:action.payload.Esignering,
             TotalEsingering:action.payload.Antal,
            //   TotalEsingering:action.payload.Esignering.length,
            }
          }
        case ON_ERROR_ESIGNERING_DELETE:{
            console.log("ON_ERROR_ESIGNERING_DELETE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }
        case ON_START_GET_ESIGNERIGN_HISTORY:{
            console.log("ON_START_GET_ESIGNERIGN_HISTORY",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:false,
              EsigneringHistory:[]
             }
          }
        case ON_GET_ESIGNERIGN_HISTORY:{
            console.log("ON_GET_ESIGNERIGN_HISTORY",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:false,
              EsigneringHistory:action.payload.EsigneringHistory,
            }
          }
        case ON_ERROR_GET_ESIGNERIGN_HISTORY:{
            console.log("ON_ERROR_GET_ESIGNERIGN_HISTORY",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
            }
          }
          case ON_START_UPDATE_ESIGNERIGN_MESSAGE:{
            console.log("ON_START_UPDATE_ESIGNERIGN_MESSAGE",action)
            return {
              ...state,
              //Esingeringtmessage:"",
              isLoadingEsingering:false
             }
          }
        case ON_UPDATE_ESIGNERIGN_MESSAGE:{
            console.log("ON_UPDATE_ESIGNERIGN_MESSAGE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.update"),
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,              
            }
          }
        case ON_ERROR_UPDATE_ESIGNERIGN_MESSAGE:{
            console.log("ON_ERROR_UPDATE_ESIGNERIGN_MESSAGE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }  
          case ON_START_UPDATE_ESIGNERIGN_MOTAGARE:{
            console.log("ON_START_UPDATE_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true
             }
          }
        case ON_UPDATE_ESIGNERIGN_MOTAGARE:{
            console.log("ON_UPDATE_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.update"),
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
              
            }
          }
        case ON_ERROR_UPDATE_ESIGNERIGN_MOTAGARE:{
            console.log("ON_ERROR_UPDATE_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }  
          case ON_START_NEW_ESIGNERIGN_MOTAGARE:{
            console.log("ON_START_NEW_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true
             }
          }
        case ON_NEW_ESIGNERIGN_MOTAGARE:{
            console.log("ON_NEW_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.Save"),
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
              
            }
          }
        case ON_ERROR_NEW_ESIGNERIGN_MOTAGARE:{
            console.log("ON_ERROR_NEW_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }  
          case ON_START_DELETE_ESIGNERIGN_MOTAGARE:{
            console.log("ON_START_DELETE_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true
             }
          }
        case ON_DELETE_ESIGNERIGN_MOTAGARE:{
            console.log("ON_DELETE_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Action.Save"),
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
              
            }
          }
        case ON_ERROR_DELETE_ESIGNERIGN_MOTAGARE:{
            console.log("ON_ERROR_DELETE_ESIGNERIGN_MOTAGARE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }  
          case ON_START_UPDATE_ESIGNERIGN_FILE:{
            console.log("ON_START_UPDATE_ESIGNERIGN_FILE",action)
            return {
              ...state,
              Esingeringtmessage:"",
              isLoadingEsingering:true
             }
          }
        case ON_UPDATE_ESIGNERIGN_FILE:{
            console.log("ON_UPDATE_ESIGNERIGN_FILE",action)
            return {
              ...state,
              Esingeringtmessage:"Uppdaterad",
              isLoadingEsingering:false,
              currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
              MainTimeLine:action.payload.CurrentEsignering.TimeLine,
              MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
              FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
              FreeInputs:action.payload.CurrentEsignering.FreeInputs,
              
            }
          }
        case ON_ERROR_UPDATE_ESIGNERIGN_FILE:{
            console.log("ON_ERROR_UPDATE_ESIGNERIGN_FILE",action)
            return {
              ...state,
              Esingeringtmessage: translate("Error.Esigning"),
              isLoadingEsingering:false
            }
          }  
  //ON_START_GET_SIGNERAD_FILE,ON_GET_SIGNERAD_FILE,ON_ERROR_GET_SIGNERAD_FILE,
  case ON_START_GET_SIGNERAD_FILE:{
    console.log("ON_START_GET_SIGNERAD_FILE",action)
    return {
      ...state,
    //  isLoadingEsingering:true,
    }
  }
case ON_GET_SIGNERAD_FILE:{
    console.log("ON_GET_SIGNERAD_FILE",action)
    return {
      ...state,
      Esingeringtmessage:"",
      isLoadingEsingering:false,
      currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
      MainTimeLine:action.payload.CurrentEsignering.TimeLine,
      MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
      FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
      FreeInputs:action.payload.CurrentEsignering.FreeInputs,
    }
  }
case ON_ERROR_GET_SIGNERAD_FILE:{
    console.log("ON_ERROR_GET_SIGNERAD_FILE",action)
    return {
      ...state,
      Esingeringtmessage: translate("Error.Esigning"),
      isLoadingEsingering:false
    }
  }
  //ON_START_GET_SIG_FILE,ON_GET_SIG_FILE,ON_ERROR_GET_SIG_FILE,
  case ON_START_GET_SIG_FILE:{
    console.log("ON_START_GET_SIG_FILE",action)
    return {
      ...state,
    }
  }
  case ON_GET_SIG_FILE:{
    console.log("ON_GET_SIG_FILE",action)
    return {
      ...state,
    }
  }
  case ON_ERROR_GET_SIG_FILE:{
    console.log("ON_ERROR_GET_SIG_FILE",action)
    return {
      ...state,
    }
  }
  //ON_START_SEND_ESIGNERIGN_REMAINDER,ON_SEND_ESIGNERIGN_REMAINDER,ON_ERROR_SEND_ESIGNERIGN_REMAINDER,
  case ON_START_SEND_ESIGNERIGN_REMAINDER:{
    console.log("ON_START_SEND_ESIGNERIGN_REMAINDER",action)
    return {
      ...state,
    }
  }
  case ON_SEND_ESIGNERIGN_REMAINDER:{
    console.log("ON_SEND_ESIGNERIGN_REMAINDER",action)
    return {
      ...state,
      Esingeringtmessage:"Skickat",
    }
  }
  case ON_ERROR_SEND_ESIGNERIGN_REMAINDER:{
    console.log("ON_ERROR_SEND_ESIGNERIGN_REMAINDER",action)
    return {
      ...state,
      Esingeringtmessage: translate("Error.Esigning"),
    }
  }
  //ON_START_ADD_ESIGNERIGN_ATTAC_FILE,ON_ADD_ESIGNERIGN_ATTAC_FILE,ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE,
  case ON_START_ADD_ESIGNERIGN_ATTAC_FILE:{
    console.log("ON_START_ADD_ESIGNERIGN_ATTAC_FILE",action)
    return {
      ...state,
      Esingeringtmessage:"",
      isLoadingEsingering:true
     }
  }
  case ON_ADD_ESIGNERIGN_ATTAC_FILE:{
    console.log("ON_ADD_ESIGNERIGN_ATTAC_FILE",action)
    return {
      ...state,
      Esingeringtmessage:"",
      isLoadingEsingering:false,
      currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
      MainTimeLine:action.payload.CurrentEsignering.TimeLine,
      MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
      FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
      FreeInputs:action.payload.CurrentEsignering.FreeInputs,
    }
  }
case ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE:{
    console.log("ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE",action)
    return {
      ...state,
      Esingeringtmessage: translate("Error.Esigning"),
      isLoadingEsingering:false
    }
  }
  //ON_START_DEL_ATT_FILE,ON_DEL_ATT_FILE,ON_ERROR_DEL_ATT_FILE,
  case ON_START_DEL_ATT_FILE:{
    console.log("ON_START_DEL_ATT_FILE",action)
    return {
      ...state,
      Esingeringtmessage:"",
      isLoadingEsingering:true
     }
  }
  case ON_DEL_ATT_FILE:{
    console.log("ON_DEL_ATT_FILE",action)
    return {
      ...state,
      Esingeringtmessage: translate("Action.delete"),
      isLoadingEsingering:false,
      currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
      MainTimeLine:action.payload.CurrentEsignering.TimeLine,
      MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
      FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
      FreeInputs:action.payload.CurrentEsignering.FreeInputs,
    }
  }
case ON_ERROR_DEL_ATT_FILE:{
    console.log("ON_ERROR_DEL_ATT_FILE",action)
    return {
      ...state,
      Esingeringtmessage: translate("Error.Esigning"),
      isLoadingEsingering:false
    }
}
//ON_START_ESIGNERING_NEW_FREEIPUT,ON_ESIGNERING_NEW_FREEIPUT,ON_ERROR_ESIGNERING_NEW_FREEIPUT,
case ON_START_ESIGNERING_NEW_FREEIPUT:{
  console.log("ON_START_ESIGNERING_NEW_FREEIPUT",action)
  return {
    ...state,
    Esingeringtmessage:"",
    isLoadingEsingering:true
   }
}
case ON_ESIGNERING_NEW_FREEIPUT:{
  console.log("ON_ESIGNERING_NEW_FREEIPUT",action)
  return {
    ...state,
    Esingeringtmessage: translate("Action.Add"),
    isLoadingEsingering:false,
    currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
    MainTimeLine:action.payload.CurrentEsignering.TimeLine,
    MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
    FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
    FreeInputs:action.payload.CurrentEsignering.FreeInputs,
  }
}
case ON_ERROR_ESIGNERING_NEW_FREEIPUT:{
  console.log("ON_ERROR_ESIGNERING_NEW_FREEIPUT",action)
  return {
    ...state,
    Esingeringtmessage: translate("Error.Esigning"),
    isLoadingEsingering:false
  }
}
//ON_START_ESIGNERING_EDIT_FREEIPUT,ON_ESIGNERING_EDIT_FREEIPUT,ON_ERROR_ESIGNERING_EDIT_FREEIPUT,
case ON_START_ESIGNERING_EDIT_FREEIPUT:{
  return {
    ...state,
    Esingeringtmessage:"",
    isLoadingEsingering:true
   }
}
case ON_ESIGNERING_EDIT_FREEIPUT:{
  return {
    ...state,
    Esingeringtmessage: translate("Action.Add"),
    isLoadingEsingering:false,
    currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
    MainTimeLine:action.payload.CurrentEsignering.TimeLine,
    MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
    FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
    FreeInputs:action.payload.CurrentEsignering.FreeInputs,
  }
}
case ON_ERROR_ESIGNERING_EDIT_FREEIPUT:{
  return {
    ...state,
    Esingeringtmessage: translate("Error.Esigning"),
    isLoadingEsingering:false
  }
}
//ON_START_ESIGNERING_DELETE_FREEIPUT,ON_ESIGNERING_DELETE_FREEIPUT,ON_ERROR_ESIGNERING_DELETE_FREEIPUT,
case ON_START_ESIGNERING_DELETE_FREEIPUT:{
  return {
    ...state,
    Esingeringtmessage:"",
    isLoadingEsingering:true
   }
}
case ON_ESIGNERING_DELETE_FREEIPUT:{
  return {
    ...state,
    Esingeringtmessage: translate("Action.remove"),
    isLoadingEsingering:false,
    currentEsingering:{...state.currentEsingering, ...action.payload.CurrentEsignering},
    MainTimeLine:action.payload.CurrentEsignering.TimeLine,
    MotArbetareEsignering:action.payload.CurrentEsignering.Mottagare,
    FilesBilagor:action.payload.CurrentEsignering.FilesBilagor,
    FreeInputs:action.payload.CurrentEsignering.FreeInputs,
  }
}
case ON_ERROR_ESIGNERING_DELETE_FREEIPUT:{
  return {
    ...state,
    Esingeringtmessage: translate("Error.Esigning"),
    isLoadingEsingering:false
  }
}
//ON_START_ESIGNERING_UPDATE_NYTT
case ON_START_ESIGNERING_UPDATE_NYTT:{
  console.log("ON_START_ESIGNERING_UPDATE_NYTT",action)
  return {
    ...state,
    ResponseMsgEsignering:{},
    Eventmessage:"",
    isLoadingEvent:false,
  }
}


        default:
           return state;
    }
}
